export default "__VITE_ASSET__b0628d84__"